<script setup>
import { systemLoading, systemLoadingOpaque } from './system-loading-state'
import AppLogo from './AppLogo'
</script>

<template>
  <div
    v-if="systemLoading"
    class="position-absolute top-0 w-100 h-100 bg-white d-flex flex-column justify-content-center gap-3 z-1"
    :class="systemLoadingOpaque ? '' : 'opacity-75'"
  >
    <AppLogo class="logo" />
    <div class="loader d-flex flex-row gap-3 align-self-center">
      <div class="spinner-grow text-secondary" />
      <div class="spinner-grow text-secondary" />
      <div class="spinner-grow text-secondary" />
    </div>
  </div>
</template>

<style scoped>
.logo {
  height: 4.5rem;
}

.loader div:nth-child(2) {
  animation-delay: .12s;
}

.loader div:nth-child(3) {
  animation-delay: .25s;
}
</style>
